import { PAGE_TYPES } from './constants';
import { getParentPagePath, getPageType } from '../../utils/window-utils';

export const getPageKey = () => {
  const splitPath = getParentPagePath().split('/');
  const pageType = getPageType();
  if (pageType === PAGE_TYPES.PIP || pageType === PAGE_TYPES.CONTENT) {
    return splitPath[2];
  }
  if (pageType === PAGE_TYPES.SEARCH || pageType === PAGE_TYPES.BROWSE) {
    return splitPath[3];
  }

  return 'Home';
};
